export default __webpack_public_path__ + "static/media/cta3.d7f85d17.png";